import { render, staticRenderFns } from "./LedesDetailForm.vue?vue&type=template&id=54b0ab43&"
import script from "./LedesDetailForm.vue?vue&type=script&lang=js&"
export * from "./LedesDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./LedesDetailForm.vue?vue&type=style&index=0&id=54b0ab43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports